import { render, staticRenderFns } from "./BookingContainers.vue?vue&type=template&id=b0831d26&scoped=true&"
import script from "./BookingContainers.vue?vue&type=script&lang=js&"
export * from "./BookingContainers.vue?vue&type=script&lang=js&"
import style0 from "./BookingContainers.vue?vue&type=style&index=0&id=b0831d26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0831d26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0831d26')) {
      api.createRecord('b0831d26', component.options)
    } else {
      api.reload('b0831d26', component.options)
    }
    module.hot.accept("./BookingContainers.vue?vue&type=template&id=b0831d26&scoped=true&", function () {
      api.rerender('b0831d26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/booking/BookingContainers.vue"
export default component.exports